import { render, staticRenderFns } from "./HeadMenuFilter.vue?vue&type=template&id=052551b3&"
import script from "./HeadMenuFilter.vue?vue&type=script&lang=js&"
export * from "./HeadMenuFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports